import { Fragment } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/layout/heading";
import { Stats } from "@/components/paid-media/reports/stats";
import { Reports } from "@/components/paid-media/reports/reports";

export const Route = createFileRoute("/dashboard/paid-media/_layout/reports")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Fragment>
      <PageHeader title="All Reports" className="mb-6" />
      <div className="space-y-6">
        <Stats />
        <Reports />
      </div>
    </Fragment>
  );
}
